import { graphql } from "../gql";

export const getFilesQueryDoc = graphql(`
  query getFiles($input: FilesInput) {
    files(input: $input) {
      ...FileFragment
    }
  }
`);
